import React, { useState, useEffect } from 'react';
import { Menu, X } from 'lucide-react';
import { Link, useLocation } from 'react-router-dom';

const Navbar = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const location = useLocation();
  const isHomePage = location.pathname === '/';

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 10) {
        setIsScrolled(true);
      } else {
        setIsScrolled(false);
      }
    };
    
    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  const scrollToSection = (id: string) => {
    if (isHomePage) {
      const element = document.getElementById(id);
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' });
      }
    } else {
      window.location.href = `/#${id}`;
    }
    setIsMenuOpen(false);
  };

  return (
    <nav 
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled 
          ? 'bg-white/25 backdrop-blur-xl border-b border-white/20 shadow-lg py-2' 
          : 'bg-transparent backdrop-blur-sm py-4'
      }`}
      style={{
        backdropFilter: 'blur(10px)',
      }}
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-16">
          <div className="flex-shrink-0">
            <Link to="/" className="flex items-center">
              <img 
                src="/lovable-uploads/03d4283a-9734-497d-8dc3-45c2afbff3f5.png" 
                alt="Grow99X Logo" 
                className="h-9 md:h-10"
              />
            </Link>
          </div>
          
          <div className="hidden md:block">
            <div className="ml-10 flex items-center space-x-8">
              <button 
                onClick={() => scrollToSection('services')} 
                className="text-grow99x-text hover:text-grow99x-orange font-medium transition-colors"
              >
                Services
              </button>
              <Link 
                to="/work" 
                className="text-grow99x-text hover:text-grow99x-orange font-medium transition-colors"
              >
                Our Work
              </Link>
              <button 
                onClick={() => scrollToSection('pricing')} 
                className="text-grow99x-text hover:text-grow99x-orange font-medium transition-colors"
              >
                Pricing
              </button>
              <button 
                onClick={() => scrollToSection('contact')} 
                className="bg-grow99x-orange hover:bg-grow99x-orange/90 text-white px-6 py-2 rounded-md shadow-md transition-all duration-300 font-medium"
              >
                Let's Talk
              </button>
            </div>
          </div>
          
          <div className="md:hidden">
            <button
              onClick={() => setIsMenuOpen(!isMenuOpen)}
              className="text-grow99x-text hover:text-grow99x-orange transition-colors"
            >
              {isMenuOpen ? <X size={24} /> : <Menu size={24} />}
            </button>
          </div>
        </div>
      </div>
      
      {isMenuOpen && (
        <div className="md:hidden bg-white/30 backdrop-blur-xl border-t border-white/20 shadow-lg">
          <div className="px-2 pt-2 pb-3 space-y-1 sm:px-3">
            <button 
              onClick={() => scrollToSection('services')}
              className="block w-full text-left px-3 py-4 text-grow99x-text hover:text-grow99x-orange font-medium transition-colors border-b border-white/10"
            >
              Services
            </button>
            <Link 
              to="/work"
              className="block w-full text-left px-3 py-4 text-grow99x-text hover:text-grow99x-orange font-medium transition-colors border-b border-white/10"
              onClick={() => setIsMenuOpen(false)}
            >
              Our Work
            </Link>
            <button 
              onClick={() => scrollToSection('pricing')}
              className="block w-full text-left px-3 py-4 text-grow99x-text hover:text-grow99x-orange font-medium transition-colors border-b border-white/10"
            >
              Pricing
            </button>
            <button 
              onClick={() => scrollToSection('contact')}
              className="block w-full text-left px-3 py-4 text-grow99x-orange font-medium transition-colors"
            >
              Let's Talk
            </button>
          </div>
        </div>
      )}
    </nav>
  );
};

export default Navbar;
